import { Controller } from "@hotwired/stimulus"

// I form di pages/Piani.js erano <div> con un pulsante onClick: Invio in un campo non invia niente.
// I pulsanti restano attivabili con la tastiera.
export default class extends Controller {
  blocca(event) {
    if (event.target.tagName === "INPUT") event.preventDefault()
  }
}
